import React, { useEffect, useState } from "react";
import { postMov } from "../helpers/rutaMovs";
import { getHoms } from "../helpers/rutaHoms";
// opcional:
import { getClienteByCodigo } from "../helpers/rutaClientes";


import { Modal } from "react-bootstrap";
import "animate.css";
import "../css/addclienteform.css";

const todayISO = () => new Date().toISOString().slice(0, 10);

const initial = {
  codmov: "",       // display
  codcli: "",
  codhom: "",
  fecmov: todayISO(),
  leyenda: "",
  usuario1: "",
};

export default function AddMovForm() {
  const [formValues, setFormValues] = useState(initial);
  const [showSuccess, setShowSuccess] = useState(false);

  const [homs, setHoms] = useState({ data: [], loading: true });

  // solo UI (no se persiste)
  const [ui, setUi] = useState({
    clienteDesc: "",
    homDesc: "",
  });

  useEffect(() => {
    getHoms()
      .then((list) => setHoms({ data: Array.isArray(list) ? list : [], loading: false }))
      .catch(() => setHoms({ data: [], loading: false }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((p) => ({ ...p, [name]: value }));
  };

  const handleHom = (e) => {
    const cod = e.target.value;
    const h = (homs.data || []).find((x) => String(x.codhom) === String(cod));
    setFormValues((p) => ({ ...p, codhom: cod }));
    setUi((p) => ({ ...p, homDesc: h?.hom || "" }));
  };

  const buscarCliente = async () => {
    const codcli = Number(formValues.codcli);
    if (!codcli) return setUi((p) => ({ ...p, clienteDesc: "" }));

    try {
      const resp = await getClienteByCodigo(codcli);
      const cli = resp?.cliente;
      setUi((p) => ({ ...p, clienteDesc: cli?.razonsocial || "" }));
    } catch {
      setUi((p) => ({ ...p, clienteDesc: "" }));
    }
  };

  const buildPayload = () => {
    const payload = { ...formValues };
    if (!payload.codmov) delete payload.codmov; // lo genera Counter si no viene
    return payload;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const resp = await postMov(buildPayload());
      console.log("✅ Movimiento creado:", resp);

      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        setFormValues({ ...initial, fecmov: todayISO() });
        setUi({ clienteDesc: "", homDesc: "" });
      }, 1600);
    } catch (err) {
      console.error("❌ Error al crear mov:", err);
    }
  };

  return (
    <>
      {!homs.loading && (
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group mt-3 col-sm-2">
                <label>Código Mov</label>
                <input className="form-control" value={formValues.codmov} disabled placeholder="Auto" />
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>Fecha</label>
                <input
                  type="date"
                  className="form-control"
                  name="fecmov"
                  value={formValues.fecmov}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>Cod. Cliente</label>
                <input
                  type="number"
                  className="form-control"
                  name="codcli"
                  value={formValues.codcli}
                  onChange={handleChange}
                  onBlur={buscarCliente}
                />
              </div>

              <div className="form-group mt-3 col-sm-6">
                <label>Cliente (desc.)</label>
                <input className="form-control" value={ui.clienteDesc} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group mt-3 col-sm-3">
                <label>HOM</label>
                <select className="form-control" value={formValues.codhom} onChange={handleHom} required>
                  <option value="">Elija opción</option>
                  {(homs.data || [])
                    .filter((x) => x?.activo !== false)
                    .sort((a, b) => (a.codhom ?? 0) - (b.codhom ?? 0))
                    .map((h) => (
                      <option key={h._id} value={h.codhom}>
                        {h.codhom} - {h.hom}
                      </option>
                    ))}
                </select>
              </div>

              <div className="form-group mt-3 col-sm-5">
                <label>HOM (desc.)</label>
                <input className="form-control" value={ui.homDesc} readOnly />
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>Usuario (cód.)</label>
                <input
                  type="number"
                  className="form-control"
                  name="usuario1"
                  value={formValues.usuario1}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-2 d-flex align-items-end">
                <button type="button" className="btn btn-outline-secondary w-100" onClick={buscarCliente}>
                  Buscar cliente
                </button>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group mt-3 col-sm-12">
                <label>Leyenda</label>
                <textarea
                  className="form-control"
                  name="leyenda"
                  rows={3}
                  value={formValues.leyenda}
                  onChange={handleChange}
                />
              </div>
            </div>

            <button type="submit" className="btn btn-dark mt-4 mb-3" id="button">
              Guardar
            </button>
          </form>
        </div>
      )}

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Movimiento generado correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
}